export var IngestionPipelineSortField;
(function (IngestionPipelineSortField) {
    IngestionPipelineSortField["INGESTION_PIPELINE_SORT_FIELD_CREATED_AT"] = "createdAt";
    IngestionPipelineSortField["INGESTION_PIPELINE_SORT_FIELD_NAME"] = "name";
})(IngestionPipelineSortField || (IngestionPipelineSortField = {}));
